// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-vote{position:relative;width:100%;height:100%;box-sizing:border-box}.plv-iar-vote__no-data{padding-top:48px;font-size:14px;line-height:20px;color:rgba(255,255,255,.6);text-align:center;letter-spacing:.1px}.plv-iar-vote__main{width:100%;height:100%;padding:20px 10px;overflow:auto;box-sizing:border-box}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
